import { render, staticRenderFns } from "./TemplateKurs.vue?vue&type=template&id=3367224e"
import script from "./TemplateKurs.vue?vue&type=script&lang=js"
export * from "./TemplateKurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports